/**
 * 虚拟file对象
 */

function VFile (id, name, isFolder, size, opts = {}) {
  this.id = id
  this.name = name
  this.isFolder = isFolder
  this.size = size
  this.opts = opts
  this.extension = this.name.substr((~-this.name.lastIndexOf('.') >>> 0) + 2).toLowerCase()
  this.paused = false
  this.error = false
  this.complete = true
  this.uploading = false
  this.uploader = false
  this.averageSpeed = 0
  this.currentSpeed = 0
}

VFile.prototype.progress = () => {
  return 1
}

export default VFile



// WEBPACK FOOTER //
// ./src/components/framework/uploader/common/v-file.js